
"use strict"

import * as parallax from './modules/moreinfo.js';
import * as moreinfo from './modules/parallax.js';

parallax.init()
moreinfo.init()